export default __webpack_public_path__ + "4f6e736daef2d8d0b553143e89e02691.png";